import { api } from "./api";
import { ClearAllCache } from "./cache";
import { promptTotpCode } from "./components/totp-code-input";
import { getNextSavedAccount, putSession, removeCurrentSavedAccount, saveAuthenticatedAccount } from "./session";

export async function authenticateWithLoginKey(loginKey) {
    ClearAllCache();

    const normalizedLoginKey = String(loginKey || "").trim();
    let result = await api.postJson("/api/v1/auth/login", {
        loginKey: normalizedLoginKey
    }, {
        handleUnauthorized: false
    });

    while (result?.data?.requiresTwoFactor) {
        const totpCode = await promptTotpCode();
        result = await api.postJson("/api/v1/auth/login", {
            loginKey: normalizedLoginKey,
            totpCode
        }, {
            handleUnauthorized: false
        });
    }

    if (!result?.data?.accessToken) {
        throw new Error(result?.error || "Access denied.");
    }

    putSession({
        sessionKey: result.data.accessToken,
        data: result.data.account
    }, normalizedLoginKey);
    saveAuthenticatedAccount(normalizedLoginKey, result.data.account);
    ClearAllCache();

    return result;
}

export async function logoutCurrentAccountAndLoginNext() {
    ClearAllCache();
    removeCurrentSavedAccount();

    const nextAccount = getNextSavedAccount();
    if (!nextAccount) {
        return false;
    }

    await authenticateWithLoginKey(nextAccount.loginKey);
    return true;
}
